import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { 
  GenerateWebsiteRequest, 
  GenerateWebsiteResponse,
  DeploymentRequest,
  DeploymentResponse,
  DeploymentStatusResponse
} from '../interfaces/api.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsiteGenerationService {
  constructor(private http: HttpClient) {}

  generateWebsite(request: GenerateWebsiteRequest): Observable<GenerateWebsiteResponse> {
    return this.http.post<GenerateWebsiteResponse>(`${environment.fastApiBaseUrl}/generate-website`, request);
  }

  deployToGitHub(folderName: string): Observable<DeploymentResponse> {
    const deploymentRequest: DeploymentRequest = { folderName };
    return this.http.post<DeploymentResponse>(`${environment.fastApiBaseUrl}/deploy-to-github`, deploymentRequest);
  }

  getDeploymentStatus(deploymentId: string): Observable<DeploymentStatusResponse> {
    return this.http.get<DeploymentStatusResponse>(`${environment.fastApiBaseUrl}/deployment-status/${deploymentId}`);
  }

  generateGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  async loadTemplate(templateNumber: number): Promise<string> {
    try {
      return await firstValueFrom(
        this.http.get(`/templates/supplier-template-${templateNumber}/index.html`, { responseType: 'text' })
      );
    } catch (error) {
      console.error(`Failed to load template ${templateNumber}:`, error);
      return '';
    }
  }

  async loadTemplatePage(templateNumber: number, pageName: string): Promise<string> {
    try {
      return await firstValueFrom(
        this.http.get(`/templates/supplier-template-${templateNumber}/${pageName}.html`, { responseType: 'text' })
      );
    } catch (error) {
      console.error(`Failed to load template page ${templateNumber}/${pageName}:`, error);
      return '';
    }
  }

  formatPhoneNumber(phone: string): string {
    if (!phone) return '';
    
    // Remove all non-numeric characters
    const cleaned = phone.replace(/\D/g, '');
    
    return `${cleaned.slice(1, 12)}`
  }

  deployWebsiteFiles(formData: FormData): Observable<DeploymentResponse> {
    return this.http.post<DeploymentResponse>(`${environment.fastApiBaseUrl}/deploy-website-files`, formData);
  }
}